/**
 * API Telefonía / CDR (Node). Rutas relativas a axios.defaults.baseURL
 * (local: /api-rh/ → proxy vue.config; staging/prod: VUE_APP_RUTA_API).
 *
 * Autenticación: el interceptor global de axios envía Authorization, user-iD e id-usuario.
 */
import axios from 'axios'

export function getCdr (params) {
  return axios.get('api/telefonia/cdr', { params })
}

/** Rango de fechas / total disponible en telefonia_cdr */
export function getCdrMeta () {
  return axios.get('api/telefonia/cdr-meta')
}

export function getStats (params) {
  return axios.get('api/telefonia/stats', { params })
}

export function getExtensions () {
  return axios.get('api/telefonia/extensions')
}

export function getSystemStatus () {
  return axios.get('api/telefonia/status')
}

/** Fallback: audio vía API Node (mismo host que CDR). params: { filename } */
export function getRecording (params) {
  return axios.get('api/telefonia/recording', {
    params,
    responseType: 'blob'
  })
}

/**
 * Whisper + coaching OpenAI por lote.
 * Body: { llamadas: [{ uniqueid, sucursal, recording_url? }] }
 */
export function analizarLoteIa (payload) {
  return axios.post('api/telefonia/ia-analizar-lote', payload || {})
}

/**
 * Baja CDR desde UCM(s) configurados → BD (solo lectura; no borra en el conmutador).
 * Body: { startDate?, endDate?, sucursal? }
 */
export function bajarLlamadas (payload) {
  return axios.post('api/telefonia/bajar-llamadas', payload || {}, {
    timeout: 180000
  })
}

export default {
  getCdr,
  getCdrMeta,
  getStats,
  getExtensions,
  getSystemStatus,
  getRecording,
  analizarLoteIa,
  bajarLlamadas
}
